export default {
  title: 'Promo codes are online only for your locations',
  body: "They apply to online and app orders. In-store redemption isn't available on your current point of sale.",
}
